export default __webpack_public_path__ + "static/media/Banner - EarBuddyz ULTRA - Black.c3f57854.jpg";